module.exports = __webpack_public_path__ + "img/devices.7367dd6a.svg";